import { MetaFunction } from "@remix-run/node";

import ScrollToTopButton from "../_component/scroll-to-top";

export const meta: MetaFunction = () => {
  return [
    { title: "Syarat dan Ketentuan" },
    { name: "description", content: "Terms and Conditions for Trustmedis Cirql" },
  ];
};

export default function TermAndCondition() {
  return (
    <div className="mx-auto flex w-full max-w-6xl justify-center px-4 pb-16">
      <div className="mt-8 w-full max-w-5xl overflow-hidden rounded-[32px] bg-white/95 shadow-2xl ring-1 ring-slate-200">
        <div className="bg-gradient-to-b from-slate-100 via-white to-white px-6 py-10 text-center sm:px-12">
          <h1 className="text-3xl font-semibold text-slate-900">Syarat dan Ketentuan</h1>
          <p className="mt-2 text-base font-light text-slate-600">
            Penggunaan Aplikasi Trustmedis Cirql
          </p>
        </div>
        <div className="space-y-8 px-6 pb-12 sm:px-12">
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">
              Kebijakan Privasi
            </h2>
            <p className="text-sm leading-relaxed text-slate-600">
              Selamat datang di Cirql, salah satu produk digital dari PT Teknologi Inovasi Solusindo (Trustmedis).
              Kebijakan privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, menyimpan, dan melindungi
              informasi pribadi Anda ketika menggunakan aplikasi dan layanan Cirql. Dengan menggunakan Cirql, Anda
              menyetujui praktik privasi sebagaimana dijelaskan dalam kebijakan ini.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">
              Informasi Pengumpulan Data
            </h2>
            <p className="text-sm leading-relaxed text-slate-600">
              Kami dapat mengumpulkan informasi pribadi secara langsung dari Anda, perusahaan tempat Anda bekerja, maupun
              dari penggunaan Anda terhadap sistem Cirql. Jenis data yang dapat kami kumpulkan meliputi:
            </p>
            <ol className="list-decimal space-y-2 pl-5 text-sm leading-relaxed text-slate-600">
              <li>
                Informasi pribadi: nama, email, nomor induk pegawai, jabatan, unit kerja, dan informasi lain terkait
                kepegawaian.
              </li>
              <li>
                Data kehadiran dan aktivitas kerja: waktu presensi, pengajuan cuti, lembur, dispensasi, dan riwayat
                persetujuan.
              </li>
              <li>
                Data perangkat dan teknis: informasi perangkat, alamat IP, jenis browser, sistem operasi, serta log
                penggunaan sistem.
              </li>
              <li>
                Dokumen pendukung: file atau bukti resmi yang diunggah untuk pengajuan administratif (seperti surat izin,
                surat tugas, dan dokumen terkait lainnya).
              </li>
            </ol>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">
              Penggunaan Informasi
            </h2>
            <p className="text-sm leading-relaxed text-slate-600">
              Informasi yang kami kumpulkan digunakan untuk:
            </p>
            <ol className="list-decimal space-y-2 pl-5 text-sm leading-relaxed text-slate-600">
              <li>Menyediakan layanan pengelolaan kepegawaian melalui Cirql.</li>
              <li>Menyimpan dan memproses data absensi, cuti, lembur, dan dispensasi sesuai kebutuhan organisasi Anda.</li>
              <li>Menyediakan fungsionalitas pelacakan status dan alur persetujuan.</li>
              <li>Mengelola akun dan autentikasi pengguna.</li>
              <li>Melakukan pemeliharaan dan peningkatan performa sistem.</li>
              <li>Mematuhi kewajiban hukum atau kebijakan internal perusahaan pengguna.</li>
            </ol>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">
              Pembagian Data Pihak Ketiga
            </h2>
            <p className="text-sm leading-relaxed text-slate-600">
              Kami dapat membagikan informasi pribadi Anda kepada pihak ketiga yang mendukung operasional Cirql, dengan
              tetap menjaga kerahasiaan data dan mematuhi peraturan yang berlaku, untuk tujuan:
            </p>
            <ol className="list-decimal space-y-2 pl-5 text-sm leading-relaxed text-slate-600">
              <li>Menyediakan layanan pengelolaan kepegawaian melalui Cirql.</li>
              <li>Menyimpan dan memproses data absensi, cuti, lembur, dan dispensasi sesuai kebutuhan organisasi Anda.</li>
              <li>Menyediakan fungsionalitas pelacakan status dan alur persetujuan.</li>
              <li>Mengelola akun dan autentikasi pengguna.</li>
              <li>Melakukan pemeliharaan dan peningkatan performa sistem.</li>
              <li>Mematuhi kewajiban hukum atau kebijakan internal perusahaan pengguna.</li>
            </ol>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">Keamanan Informasi</h2>
            <p className="text-sm leading-relaxed text-slate-600">
              Kami berkomitmen untuk menjaga keamanan informasi pribadi Anda dengan menggunakan standar tertinggi dan
              teknologi terkini. Dalam rangka itu, kami telah:
            </p>
            <ul className="list-disc space-y-2 pl-5 text-sm leading-relaxed text-slate-600">
              <li>
                Mengimplementasikan Sistem Manajemen Keamanan Informasi (ISMS) berdasarkan ISO 27001 untuk melindungi
                kerahasiaan, integritas, dan ketersediaan data.
              </li>
              <li>
                Menggunakan teknologi otentikasi tambahan, termasuk OTP (One-Time Password) saat login, untuk memastikan
                hanya pengguna yang berwenang yang dapat mengakses data.
              </li>
              <li>Menerapkan enkripsi data saat transit dan saat disimpan.</li>
              <li>
                Mengaktifkan pengendalian akses berbasis peran (role-based access control) dan pelacakan aktivitas (audit
                trail).
              </li>
            </ul>
            <p className="text-sm leading-relaxed text-slate-600">
              Kami secara berkala mengevaluasi dan meningkatkan sistem keamanan untuk memastikan perlindungan maksimal
              terhadap informasi Anda, serta mematuhi peraturan yang berlaku di Indonesia maupun standar industri global.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">Perubahan dan Kebijakan</h2>
            <p className="text-sm leading-relaxed text-slate-600">
              Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. Setiap perubahan akan kami umumkan melalui
              aplikasi atau media resmi kami. Anda disarankan untuk memeriksa halaman ini secara berkala guna mengetahui
              pembaruan terbaru.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">Kontak</h2>
            <p className="text-sm leading-relaxed text-slate-600">
              Jika Anda memiliki pertanyaan, saran, atau keluhan mengenai kebijakan privasi ini, silakan hubungi kami melalui:
            </p>
            <ul className="space-y-2 text-sm leading-relaxed text-slate-600">
              <li>Email: <a className="text-[#0f4d9b] underline" href="mailto:support@trustmedis.com">support@trustmedis.com</a></li>
              <li>Website: <a className="text-[#0f4d9b] underline" href="https://trustmedis.com">https://trustmedis.com</a></li>
              <li>Telepon: 0811 34 1212</li>
              <li>Perusahaan: PT Teknologi Inovasi Solusindo</li>
              <li>Alamat: Jl. Kertajaya Indah Timur XVI No.32, Gebang Putih, Kec. Sukolilo, Surabaya, Jawa Timur 60117</li>
            </ul>
            <p className="text-sm leading-relaxed text-slate-600">
              Dengan menggunakan Cirql, Anda menyatakan bahwa Anda telah membaca, memahami, dan menyetujui Kebijakan
              Privasi ini.
            </p>
          </section>
        </div>
      </div>
      <ScrollToTopButton />
    </div>
  );
}
